import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { OModal as OModalComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OModalConfig = {
  emptyLabel: 'OModal',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-modal`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OModal = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div data-testid="o-modal-comp" data-component-name="o-modal" id={componentId} className={clsx(styleclass)}>
      <EditableComponent config={OModalConfig} {...props}>
        <OModalComp {...props} />
      </EditableComponent>
    </div>
  );
};
